<template>
  <div>
    <div class="cont-list">
      <div class="list-item" v-for="(item, index) in dataList" :key="index">
         <div v-if="item.houseRelation=='02'" class="jiaobiao " ><span class="txt">户主</span></div>
        <div style="padding: 10px">
          <div class="card-item">
            <span class="xm">{{item.name}}</span>
            <span class="idNumber">{{(item.idNumber)}}</span>
          </div>
          <div class="card-item">
            <span  class="value">联系方式：{{item.phone}}</span>
          </div>
           <div class="card-item">
            <span  class="value">与户主关系：{{item.houseRelation_dictText}}</span>
          </div>
        </div>
        <div class="card-btn" v-if="typeShow">
          <div style="border-right: 1px solid #e2e2e2;" @click="clickEdit(item)">编辑</div>
          <div  @click="clickDelete(item)">注销</div>
        </div>
      </div>
    </div>
    
  
  </div>
</template>

<script>
 
export default {
  props: {
    list: {
      type: Array,
      default() {
        return [];
      }
    },
	idNumber: {
	  type: String,
	  default() {
	    return "";
	  }
	},
	typeShow: {//false 不是户主 true 是户主
	  type: Boolean,
	  default() {
	    return false;
	  }
	},
    houseNumber: {
    	type: String,
    	default: ''
    },
  },
  data() {
    return {
      show:false,
      currIndex:0,
      jsyyList:[],
      jsyy:'',
      dataList:[]
    };
  },
 created() {
 },
 watch: {
   list: {
   	immediate: true,
   	handler() {
   		this.dataList = this.list;
		},
	},
   },
  methods: {
    clickEdit(item) {
      this.$emit('onEdit',item);
    },
    clickDelete(item){
      this.$emit('onDelete',item);
    },
   
  }
};
</script>

<style lang="less" scoped>


.cont-list {
  padding: 8px 14px;
   box-sizing:border-box;
}
.list-item {
  background: #fff;
  border-radius: 6px;
  padding-bottom: 0;
  margin-bottom: 10px;
  box-shadow: 0px 1px 8px 0 rgba(0, 0, 0, 0.08);
  position: relative;
  overflow: hidden;

  .top {
    height: 35px;
    border-bottom: 1px solid #e2e2e2;
    padding: 0 6px;
    display: flex;
    align-items: center;
    font-size: 14px;

    .icon-house {
      width: 16px;
      height: 16px;
      margin-right: 10px;
    }
    .houseNumber {
      color: #696969;
    }
  }

  .card-item {
    display: flex;
    font-size: 14px;
    align-items: center;
    margin-bottom: 10px;
    flex-wrap: wrap;
    .xm {
      color: #333;
      font-size: 15px;
      font-weight: 500;
      margin-right: 12px;
    }
    .idNumber {
      color: #696969;
    }
    .icon {
      width: 16px;
      height: 16px;
      margin-right: 6px;
    }
    .value {
      color: #333;
      font-size: 14px;
    }

    .tag {
      padding: 4px 6px;
      background: #e5f2ff;
      border: 1px solid #4d9bfd;
      border-radius: 8px;
      color: #4d9bfd;
      font-size: 12px;
      margin-right: 10px;
      margin-bottom: 4px;
    }
  }
}

.card-btn {
  display: flex;
  align-items: center;
  text-align: center;
  border-top: 1px solid #e2e2e2;
  // margin-top: 20px;

  div {
    flex: 1;
    height: 40px;
    line-height: 40px;
    font-size: 14px;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;

    &:active {
      background-color: #eeeeee;
    }
  }
}

.jiaobiao {
  width: 80px;
  height: 80px;
  background: #4d9bfd;
  color: #fff;
  display: flex;
  align-items: flex-end;
  transform: rotate(45deg);
  -webkit-transform: rotate(45deg);
  position: absolute;
  font-size: 14px;
  top: -40px;
  right: -40px;
  justify-content: center;
}
.jiaobiao .txt {
  position: relative;
  bottom: 4px;
  letter-spacing: 1px;
}
</style>
